module.exports = __webpack_public_path__ + "static/media/timesheet_export.9bd0198f.svg";